import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SessionStorageService } from '../services/session-storage.service';
import { tokenEstaExpirado } from '../core/utils/token.util';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
      private authService: AuthService,
      private sessionStorageService: SessionStorageService,
      private router: Router
    ) { }

    canActivate(): boolean {
      const token = this.sessionStorageService.getToken();

      if (!token || tokenEstaExpirado(token)) {
        this.sessionStorageService.clearSession();
        this.router.navigate(['/login']);
        return false;
      }

      return true;
    }
}
